import './polyfills';
import 'reflect-metadata';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { LoadScript } from '@react-google-maps/api';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <LoadScript googleMapsApiKey={'AIzaSyDQiYxXNlE6zyaABIKNoaVBjY3jESorMa8'} libraries={['drawing', 'places']}>
    <App />
  </LoadScript>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
